// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'afc882667e9913a38665aa910faa7356c1ec4777';
export const BUILD_NUMBER = '269';
export const BUILD_TIMESTAMP = '2026-10-20T23:13:30.333Z';
